import React from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import Switch from "react-switch";

import swal from 'sweetalert';

import { MOMENT_SPANISH_LANG } from "../../config/defaults";

moment.locale('es', MOMENT_SPANISH_LANG);

class NewSurvey extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading : false,
            options : [],
            question : "",
            isRequired : false,
            isActive : true
        };
        
        this.onAddChoice = this.onAddChoice.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onDeleteItem = this.onDeleteItem.bind(this);
    }
    onAddChoice(e){
        e.preventDefault();

        const { choice } = e.target.elements;
        
        if (choice.value !== ""){
            const {options} = this.state;
            if (options.indexOf(choice.value) >= 0){
                swal("Esa opción ya existe");
            } else{
                options.push(choice.value);
                this.setState({options}, ()=>{
                    choice.value = "";
                });
            }
        } else{
            choice.focus();
        }

    }

    onSave(){
        const { question, options, isRequired, isActive } = this.state;
        this.setState({isLoading: true}, ()=>{
            if (question !== ""){
                if (options.length < 2){
                    swal("Debes poner al menos dos opciones");
                    this.setState({ isLoading: false });
                } else{
                    const 
                        self = this,
                        _time = moment().unix();

                    this.props.firebase.newRoom("events", self.props.event.id, "surveys", { question, options, time: _time, isRequired, isActive}, this.state.survey_id)
                        .then(function (data) {
                            if (self.state.survey_id !== undefined){
                                data = {};
                                data.id = self.state.survey_id;
                            }
                            self.setState({isLoading: false, survey_id  : data.id}, ()=>{
                                swal("", "La encuesta ha sido guardada", "success");
                            });
                        })
                        .catch((err) => {
                            self.setState({ isLoading: false });
                        });
                }
            } else{
                swal("Debes poner una pregunta");
                this.setState({ isLoading: false });
            }
        });
    }
    onDeleteItem(option){
        const 
            {options} = this.state,
            index = options.indexOf(option);

        if (index >= 0){
            options.splice(index, 1);
            this.setState({options});
        }
    }

    render() {
        return (
                <div className="wizard clearfix">
                    <div className="steps clearfix">
                        <h5 id="wizard1-h-0" tabIndex="-1" className="title current">Nueva encuesta</h5>
                    </div>
                    <div className="content clearfix pd-30 pd-sm-40">
                        <div className="row row-xs align-items-center mg-b-20">
                            <div className="col-md-4">
                                <label className="form-label mg-b-0">Titulo</label>
                            </div>
                            <div className="col-md-8 mg-t-5 mg-md-t-0">
                            <input type="text" className="form-control" placeholder="Ingresa aqui la pregunta" name="name" value={this.state.question} onChange={(e)=>{this.setState({question : e.target.value})}}/>
                            </div>
                        </div>
                        <div className="row row-xs align-items-center mg-b-20">
                            <div className="col-md-4">
                                <label className="form-label mg-b-0">Es de diligenciamiento obligatorio</label>
                            </div>
                            <div className="col-md-4 mg-t-5 mg-md-t-0">
                                <Switch onChange={(newState, control) => { this.setState({isRequired : newState}) }} checked={this.state.isRequired} />
                            </div>
                        </div>
                        <form onSubmit={this.onAddChoice}>
                            <div className="row row-xs align-items-center mg-b-20">
                                <div className="col-md-4">
                                    <label className="form-label mg-b-0">Opciones</label>
                                </div>
                                <div className="col-md-8 mg-t-5 mg-md-t-0">
                                    <div className="survey-add-option">
                                        <input type="text" className="form-control" placeholder="Ingresa una opción" name="choice" defaultValue="" />
                                        <button><i className="fas fa-plus"/></button>
                                    </div>
                                </div>
                            </div>
                        </form>
                        <div className="row row-xs align-items-center mg-b-20">
                            <div className="col-md-4"></div>
                            <div className="col-md-8 mg-t-5 mg-md-t-0">
                                {this.state.options.map((option)=>{
                                    return(
                                        <div key={option} className="survey-new-option">
                                            <button onClick={()=>{this.onDeleteItem(option)}}><i className="fas fa-times"/></button>
                                            <span>{option}</span>
                                        </div>
                                    )
                                }, this)}
                            </div>
                        </div>

                        <div className="row row-xs align-items-center mg-b-20">
                            <div className="col-md-4">
                                <label className="form-label mg-b-0">Debe lanzarse inmediamente sea creada?</label>
                            </div>
                            <div className="col-md-8 mg-t-5 mg-md-t-0">
                                <Switch onChange={(newState, control) => { this.setState({ isActive: newState }) }} checked={this.state.isActive} />
                                {(!this.state.isActive) && (
                                    <div className="alert alert-warning">Para que tus usuarios <strong>intereactúen</strong> con esta encuesta deberas ingresar a esta página y usar el boton <strong>"Iniciar Encuesta"</strong>.</div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="actions clearfix">
                        <ul role="menu" aria-label="Pagination">
                            <li className="disabled" aria-hidden="false" aria-disabled="false"><Link to="./surveys" role="menuitem"><i className="fas fa-arrow-left" /> Volver</Link></li>

                            <li aria-hidden="false" aria-disabled="false">
                                <button disabled={this.state.isLoading} type="button" onClick={this.onSave} className="btn btn-az-primary btn-block" role="menuitem"><i className={"fas fa-" + (this.state.isLoading ? "spinner fa-spin" : "save")} /> Guardar</button>
                            </li>
                        </ul>
                    </div>
                </div>
        )
    }
}

export default NewSurvey;